import { Checkbox } from '@/components/ui/checkbox'

export type PackagedItemMultiSelectOption = {
  id: string
  name: string
  sku: string
}

type PackagedItemMultiSelectProps = {
  options: PackagedItemMultiSelectOption[]
  selectedIds: string[]
  onChange: (ids: string[]) => void
  disabled?: boolean
  emptyMessage: string
}

export function PackagedItemMultiSelect({
  options,
  selectedIds,
  onChange,
  disabled = false,
  emptyMessage,
}: PackagedItemMultiSelectProps) {
  const selectedSet = new Set(selectedIds)

  if (options.length === 0) {
    return <p className='text-sm text-muted-foreground'>{emptyMessage}</p>
  }

  return (
    <div className='space-y-2 rounded-md border p-3'>
      {options.map((option) => {
        const checkboxId = `lex-packaged-item-${option.id}`
        const isChecked = selectedSet.has(option.id)
        return (
          <label
            key={option.id}
            htmlFor={checkboxId}
            className='flex cursor-pointer items-start gap-3 text-sm'
          >
            <Checkbox
              id={checkboxId}
              checked={isChecked}
              disabled={disabled}
              onCheckedChange={(checked) => {
                if (checked === true) {
                  onChange([...selectedIds, option.id])
                  return
                }
                onChange(selectedIds.filter((id) => id !== option.id))
              }}
            />
            <span className='min-w-0'>
              <span className='block font-medium'>{option.name}</span>
              <span className='mt-0.5 block text-muted-foreground'>
                {option.sku}
              </span>
            </span>
          </label>
        )
      })}
    </div>
  )
}
